import React, { Component } from "react";
import axios from "axios";

class Sucursales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      options: [],
      current: {
        nombre: "Selecciona una opción"
      }
    };
  }

  componentDidMount() {
    axios.get("https://sportium.com.mx/api/branchs/").then(
      response => {
        // console.log(response);
        this.setState({
          options: response.data
        });
      },
      error => console.log(error)
    );
  }

  click(index, item) {
    this.setState({
      current: item
    });
    this.setState({
      active: false
    });
    if (this.props.onOptionSelected) this.props.onOptionSelected(item);
  }

  toggleOptions() {
    if (this.state.active) {
      this.setState({
        active: false
      });
    } else {
      this.setState({
        active: true
      });
    }
  }

  render() {
    const Options = this.state.options.map((item, $index) => (
      <div
        className="survey-select-option"
        key={item._id}
        onClick={() => this.click($index, item)}
      >
        <span> {item.nombre} </span>{" "}
      </div>
    ));
    return (
      <div className="survey-question">
        <div className="survey-question-text middle">
          {" "}
          ¿Qué sucursal estas calificando? <span>*</span>{" "}
        </div>{" "}
        <div
          className="current-select-option current"
          onClick={this.toggleOptions.bind(this)}
        >
          {" "}
          {this.state.current.nombre}{" "}
        </div>{" "}
        <div
          className={`survey-select-options middle ${
            this.state.active ? "open" : "close"
          }`}
        >
          {" "}
          {Options}{" "}
        </div>{" "}
      </div>
    );
  }
}

export default Sucursales;



// WEBPACK FOOTER //
// ./src/components/Sucursales.js